// src/components/NotFoundModule.js
import React from 'react';
// Ya no necesitamos useAuth aquí, el layout lo maneja

// Recibe onLogout, navigateTo y currentView (del AppLayout)
function NotFoundModule({ navigateTo }) { // onLogout y currentView no se usan directamente aquí, pero se pueden pasar
  // Las funciones de toggle y getMenuItemClasses/getSubMenuItemClasses ya no son necesarias aquí, las maneja AppLayout
  // const toggleUserDropdown = () => {};
  // const toggleEcommerceSubmenu = () => {};
  // const getMenuItemClasses = (viewName) => { /* ... */ };
  // const getSubMenuItemClasses = (viewName) => { /* ... */ };

  return (
    // Solo el contenido principal del módulo 404
    <div className="flex flex-col items-center justify-center p-6 bg-gray-100 min-h-full"> {/* min-h-full para ocupar espacio */}
      <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
      <p className="text-xl text-gray-600 mb-8">Página no encontrada.</p>
      <button onClick={() => navigateTo('dashboard')} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg focus:outline-none focus:shadow-outline transition duration-300 ease-in-out">
        Volver al Dashboard
      </button>
    </div>
  );
}

export default NotFoundModule;
